import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../utils/immutable";
import { IAction } from "../../../../models/Action";
import { IPropagation, STATE_IDENTIFIER } from "./constants";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";

const { STEP_ONE, PROPAGATIONS, DEL_STATE, ADD_EDIT_STATE } = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_PROPAGATIONS_SUCCESS]: (state: any, action: any) => {
    let tmpList: IPropagation[] = [];
    action.payload.map((el: any, i: number) => {
      tmpList[i] = {
        propagationId: el.id,
        sourceTargetId: el.sourceTargetId,
        sourceIdentitySystemId: el.sourceIdentitySystemId,
        destTargetId: el.destTargetId,
        destIdentitySystemId: el.destIdentitySystemId,
      };
    });
    return immutableSet([STEP_ONE, PROPAGATIONS], tmpList, state);
  },
  [actionTypes.GET_PROPAGATIONS_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_ONE, PROPAGATIONS], [], state),

  [actionTypes.POST_UPDATE]: (state: any, action: any) =>
    immutableSet([STEP_ONE, ADD_EDIT_STATE], IResponseState.PENDING, state),
  [actionTypes.POST_UPDATE_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_ONE, ADD_EDIT_STATE], IResponseState.SUCCESS, state),
  [actionTypes.POST_UPDATE_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_ONE, ADD_EDIT_STATE], IResponseState.ERROR, state),

  [actionTypes.POST_DELETE]: (state: any, action: any) =>
    immutableSet([STEP_ONE, DEL_STATE], IResponseState.PENDING, state),
  [actionTypes.POST_DELETE_SUCCESS]: (state: any, action: any) =>
    immutableSet([STEP_ONE, DEL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.POST_DELETE_FAILURE]: (state: any, action: any) =>
    immutableSet([STEP_ONE, DEL_STATE], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
